<div class="fullWidth mt-10">
  @for (panel of panels; track panel; let i = $index) {
    <app-respondent-distribution [survey]="survey" [panel]="panel"></app-respondent-distribution>
  }
</div>
